import { render } from "./SecondDetail.vue?vue&type=template&id=a0e5d162"
import script from "./SecondDetail.vue?vue&type=script&lang=js"
export * from "./SecondDetail.vue?vue&type=script&lang=js"

import "./SecondDetail.vue?vue&type=style&index=0&id=a0e5d162&lang=scss"

import exportComponent from "E:\\公司项目\\双碳\\gdtt-front\\gdtt\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__